import { Directive, ElementRef, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Validator, NG_VALIDATORS, FormControl, NgControl } from '@angular/forms';

import { CnpjCpfService } from '../../../core';

@Directive({
    selector: '[sgtCnpjCpf]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CnpjCpfDirective), multi: true }
    ]
})
export class CnpjCpfDirective implements OnChanges, Validator {
    element: any;

    // É passado o tipo da pessoa (Física ou Jurídica)
    @Input() sgtCnpjCpf: number;
    @Output() ngModelChange = new EventEmitter<string>()
    @Input() ngControl: NgControl;
    @Input() isValidate = true; // Se deve validar o CNPJ/CPF
    @Input() isApplyMask = true; // Se deve aplicar a máscara do CNPJ/CPF

    constructor(private el: ElementRef,
                // private formControl: FormControl,
                private cnpjCpfService: CnpjCpfService) {

        this.element = jQuery(this.el.nativeElement) as any;

        /** Ao colar algum valor no input, formatamos ele */
        this.element.on('paste', (e) => {
            // Se for para aplicar a máscara, alteramos o model com o valor formatado
            if (this.isApplyMask) {
                // Obtendo o valor colado
                let value = (e.originalEvent || e).clipboardData.getData('text/plain') as string;
                // Formatando o valor colado
                value = this.element.masked(value) as string;
                // Aplicando o valor formatado
                this.ngModelChange.emit(value);
            }
        });
    }

    /** Aplica a máscara no elemento */
    private applyMask() {
        if (this.sgtCnpjCpf === 1) { // Pessoa Física
            this.element.mask('000.000.000-00', {placeholder: '___.____.___-__'});
        } else { // Pessoa Jurídica
            this.element.mask('00.000.000/0000-00', {placeholder: '__.___.___/____-__'});
        }
    }

    /** Remove a máscara aplicada no elemento */
    private removeMask() {
        this.element.unmask();
        this.element.removeAttr('placeholder');
    }

    /** Realiza a validação do FormControl de CNPJ/CPF */
    validate(c: FormControl) {
        // Se estiver configurado para não validar, então não retornamos nenhum erro
        if (!this.isValidate) {
            return null;
        }

        // Validando CNPJ/CPF
        const isValid = this.cnpjCpfService.validar(this.sgtCnpjCpf, c.value);
        if (!isValid) {
            return {
                cnpjCpfInvalido: {
                    valid: false
                }
            }
        }
        return null;
    }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            // Alterações no tipo da pessoa
            if (propName === 'sgtCnpjCpf') {
                const propTipo = changes[propName];

                if (this.isApplyMask) {
                    this.applyMask();
                }

                // Se não for a primeira alteração do tipo da pessoa, então setamos o Model do CNPJ/CPF para null
                if (!propTipo.isFirstChange()) {
                    this.ngModelChange.emit(null);
                }
            } else if (propName === 'isValidate') {
                if (!changes[propName].isFirstChange()) {
                    this.ngControl.control.updateValueAndValidity();
                }
            }  else if (propName === 'isApplyMask') {
                if (this.isApplyMask) {
                    this.applyMask();
                } else {
                    this.removeMask();
                }
            }
        }
    }
}
